module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAJFJREFUSA3tlEEKgDAMBI0v8eb/3+UjVIRCiTnMYUsjphcbWLPJpK2d91rcWl38hHZs+0tpA37H5pEwLD0ShpV7IcqGRCG9gXbRXLwdjVGDU5IhqlMqkzJDZ/X7bUqZ5U32k0ObdwDSyqR3k95hopN2SQyppgqjpJquiDUS9Ct9Y6kp0dUoCaVeU8R6GmSfltgFESwriJQ5jh8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Polska.png
// module id = 483
// module chunks = 7